import styled from 'styled-components'

const CheckboxContainer = styled.div`
  margin-right: 6px;
`

CheckboxContainer.displayName = 'CheckboxContainer'

export default CheckboxContainer
